import LegacyAccessPage from './LegacyAccessPage';
export default LegacyAccessPage;
